import { User } from '../../shared';

export class Historique {
    constructor(
        public id?: number,
        public code?: string,
        public details?: string,
        public donneeAvant?: string,
        public donneeApres?: string,
        public pieceJointeId?: number,
        public userId?: number,
        public candidatureId?: number,
        public candidatureFormationId?: number,
        public dateCreation?: any,

        //Chargé dynamiquement
        public user? : User
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/historique/historique.model.ts